
import { Component, HostListener, OnInit } from '@angular/core';
import { DeviceService } from '../services/device-service/device.service';
import { ColDef, ColGroupDef ,GridOptions, GridReadyEvent, PaginationChangedEvent } from 'ag-grid-community';
import { AG_GRID_PAGE_SIZE_OPTIONS, AG_GRID_DEFAULT_PAGE_SIZE } from '../shared/ag-grid/ag-grid-pagination.util';

import { AgGridAngular } from 'ag-grid-angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';
import { get } from 'lodash'; // for copy data cell value
import { CommentCellRendererComponent } from '../comment-cell-renderer/comment-cell-renderer.component';
import { AgGridCopyCellTooltipDirective } from '../shared/ag-grid/ag-grid-copy-cell-tooltip.directive';

@Component({
  selector: 'app-function-app',
  standalone: true,
  imports: [CommonModule,AgGridAngular,MatFormFieldModule,MatSelectModule,MatSelectModule, MatIconModule,
    CommentCellRendererComponent,
    AgGridCopyCellTooltipDirective,
  ],
  templateUrl: './function-app.component.html',
  styleUrl: './function-app.component.scss'
})
export class FunctionAppComponent implements OnInit{
  rowData: any;
  gridApi: any;
  page: number = 0;
  size: number = 25;
  totalElements: any;
  sortFlag: boolean = false;
  deviceId:any;
  paginationPageSize = AG_GRID_DEFAULT_PAGE_SIZE;
  readonly pageSizeOptions = AG_GRID_PAGE_SIZE_OPTIONS;
  currentPage:any;
  rowHeight = 100;
  localStorageGatewayId:string | null='';

constructor(private deviceService:DeviceService){}
ngOnInit(): void {
   console.log(localStorage.getItem('gatewayId'))
   if((localStorage.getItem('gatewayId')!=null))
   {
    this.localStorageGatewayId = localStorage.getItem('gatewayId');
   }
   else{
    this.localStorageGatewayId ='';
   }

}
formatUtcDate(value: any): string {
  if (value === undefined) {
    return '';
  }
  if (value === null || value === '') {
    return 'N/A';
  }
  return moment.utc(value).format('YYYY-MM-DD HH:mm:ss');
}

 defaultColDef: ColDef = {
    sortable: true,
    sortingOrder: ['asc', 'desc'],
    sort: 'desc',
    floatingFilter: false,
    resizable: true,
    wrapText: false,
    autoHeight: false
  };

 columnDefs: (ColDef | ColGroupDef)[] = [

  // // 🔹 Device Id (Single column – no grouping)
  // {
  //   headerName: 'Device Id',
  //   field: 'gatewayId',
  //   valueGetter: (params) => params.data?.gatewayId || 'N/A',
  //   pinned: 'left'
  // },

  // 🔹 Config Version Group
  {
    headerName: 'Config Version',
    children: [
      {
        headerName: 'Requested',
        field: 'requestedConfigVersion',
        valueGetter: (params) => params.data?.requestedConfigVersion || 'N/A',
      },
      {
        headerName: 'Responded',
        field: 'respondedConfigVersion',
        valueGetter: (params) => params.data?.respondedConfigVersion || 'N/A',
      },
      {
        headerName: 'Installed',
        field: 'installedConfigVersion',
        valueGetter: (params) => params.data?.installedConfigVersion || 'N/A',
      }
    ]
  },

  // Firmware Version Group
  {
    headerName: 'Firmware Version',
    children: [
      {
        headerName: 'Requested',
        field: 'requestedFirmwareVersion',
        valueGetter: (params) => params.data?.requestedFirmwareVersion || 'N/A',
      },
      {
        headerName: 'Responded',
        field: 'respondedFirmwareVersion',
        valueGetter: (params) => params.data?.respondedFirmwareVersion || 'N/A',
      },
      {
        headerName: 'Installed',
        field: 'installedFirmwareVersion',
        valueGetter: (params) => params.data?.installedFirmwareVersion || 'N/A',
      }
    ]
  },
  // Config Timestamp Group
  {
    headerName: 'Config Date (UTC)',
    children: [
      {
        headerName: 'Requested',
        field: 'requestedConfigTimestamp',
        valueGetter: (params) => this.formatUtcDate(params?.data?.requestedConfigTimestamp),
      },
      {
        headerName: 'Device',
        field: 'deviceConfigTimestamp',
        valueGetter: (params) => this.formatUtcDate(params?.data?.deviceConfigTimestamp),
      }
    ]
  }

];

  public gridOptions: GridOptions = {
    enableBrowserTooltips: true,
    tooltipShowDelay: 500,
    tooltipHideDelay: 1000,
    suppressRowTransform: true,
    rowHeight: 36,
    
    // context: {
    //   componentParent: this  // ✅ Pass this reference
    // },
     // Helps with dynamic height
    // getRowHeight: (params) => {
    //   const details = params?.data?.details || '';
    //   const baseHeight = 130;
    //   const lineLength = 90;
    //   const lineHeight = 20;
    //   const lineCount = Math.ceil(details.length / lineLength);
    //   return baseHeight + lineCount * lineHeight;
    // }

  }
  deviceHistoryPayload = {
    "page":0,
    "size":25,
    "filters":
    [
      {"field":"gatewayId","operator":"like","value":""}

    ],
    "sorts":
    [
      {"field":"id","direction":"desc"}

    ]
  }
  onPaginationChanged(event: PaginationChangedEvent): void {
    this.currentPage = event.api.paginationGetCurrentPage();
    this.deviceHistoryPayload.page=this.currentPage;
}

  sortForAgGrid(sortModel: any) {
    if ( sortModel[0] == undefined ||sortModel[0] == null ||sortModel[0].colId == undefined ||sortModel[0].colId == null) {
      return;
    }
    this.sortFlag = true;
    switch (sortModel[0].colId) {
      case 'gatewayId': {
        this.deviceHistoryPayload.sorts[0].field = 'gatewayId';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'requestedConfigVersion': {
        this.deviceHistoryPayload.sorts[0].field = 'requestedConfigVersion';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'requestedFirmwareVersion': {
        this.deviceHistoryPayload.sorts[0].field = 'requestedFirmwareVersion';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'respondedConfigVersion': {
        this.deviceHistoryPayload.sorts[0].field = 'respondedConfigVersion';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'respondedFirmwareVersion': {
        this.deviceHistoryPayload.sorts[0].field = 'respondedFirmwareVersion';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'installedConfigVersion': {
        this.deviceHistoryPayload.sorts[0].field = 'installedConfigVersion';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'installedFirmwareVersion': {
        this.deviceHistoryPayload.sorts[0].field = 'installedFirmwareVersion';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'requestedConfigTimestamp': {
        this.deviceHistoryPayload.sorts[0].field = 'requestedConfigTimestamp';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      case 'deviceConfigTimestamp': {
        this.deviceHistoryPayload.sorts[0].field = 'deviceConfigTimestamp';
        this.deviceHistoryPayload.sorts[0].direction = sortModel[0].sort;
        break;
      }
      default: {
      }
    }
  };

  /* Start Copy Data cell Value function   */
  contextMenu: { visible: boolean; x: number; y: number; value: any } = {
    visible: false,
    x: 0,
    y: 0,
    value: ''
  };
  selectedCellValue: string = '';
  contextMenuVisible: boolean = false;
  contextMenuPosition = { x: 0, y: 0 };

  getNestedProperty(obj: any, path: string): any {
    return get(obj, path, 'N/A'); // 'N/A' if value is undefined
  }


  onCellContextMenu(event: any) {
    event.event.preventDefault(); // Prevent the browser's default context menu

    let cellValue;
    const columnField = event.colDef.field;

    if (columnField === 'updateOn') {
      const updateOn = event?.data?.updateOn;
      if (updateOn === undefined) {
        cellValue = '';
      } else if (updateOn === null || updateOn === '') {
        cellValue = 'N/A';
      } else {
        cellValue = moment.utc(updateOn).format('YYYY-MM-DD HH:mm:ss');
        // issue#2398 start
        // Removed local() to ensure copied value remains in UTC exactly as displayed
        // Description: Copy now uses moment.utc(...).format(...) so clipboard time matches grid's UTC rendering
        // issue#2398 end
      }
    } else if (event.colDef.valueGetter) {
      cellValue = event.colDef.valueGetter({ data: event.data });
    } else {
      cellValue = this.getNestedProperty(event.data, columnField);
    }

    // Set context menu visibility and position
    this.contextMenu = {
      visible: true,
      x: event.event.clientX,
      y: event.event.clientY,
      value: cellValue || 'N/A',
    };
  }


  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value).then(() => {
      console.log('Copied to clipboard:', value);
      this.contextMenu.visible = false;  // Hide context menu after copying
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }


  // Hide context menu on outside click
  @HostListener('document:click')
  onDocumentClick(): void {
    this.contextMenu.visible = false;
  }
  preventDefaultContextMenu(event: MouseEvent): void {
    event.preventDefault();
  }
  /* End Copy Data cell Value function   */

   onGridReady(params: GridReadyEvent) {

      this.deviceId = localStorage.getItem('deviceId');
      this.gridApi = params;
      // this.gridApi.api.sizeColumnsToFit();


      console.log("= ",this.gridApi.api.paginationGoToNextPage)
      const dataSource = {
        getRows: (params: any) => {
          this.sortForAgGrid(params.sortModel);
          this.gridApi.api.setFilterModel(
              this.deviceHistoryPayload.filters[0] = {
                field: 'gatewayId',
                operator:'like',
                value: this.localStorageGatewayId ?? ''
              }
            )
          this.deviceService
            .getDeviceDetailsSearch(this.deviceHistoryPayload)
            .subscribe({
              next: (data: any) => {
                if (data?.content) {
                  this.rowData = data?.content;
                  console.log('data :', this.rowData);
                  this.totalElements = data?.totalElements;
                  console.log('totalElements :', this.totalElements);
                  params.successCallback(this.rowData, this.totalElements);
                  const currentPageData = data?.content.reduce((acc:any,item:any)=>{
                    acc[item.id] = item
                    return acc
                  },{} as any);
                  this.deviceService.fetchCurrentPageData = {...this.deviceService.fetchCurrentPageData, ...currentPageData}
                  console.log({NewData:this.deviceService.fetchCurrentPageData})
                }
              },
              error: (error) => {
                console.error('API Error:', error);
                params.failCallback();
              },
            });
        },
      };
      this.gridApi.api.setGridOption('datasource', dataSource);
    }

}

